// AI-CONTEXT: See docs/features/dashboard-participation-ladder-growth-card.md
import { useMemo } from 'react'
import RouteOutlinedIcon from '@mui/icons-material/RouteOutlined'
import useSharedCollection from '../../firebase/useSharedCollection'

/**
 * Traject filter chip — mirrors DashboardLocationFilter but over
 * PersonaRoutes. Option values are `route.ID` (what `persona.RouteID` stores).
 *
 * @param {object} props
 * @param {string} props.selectedRouteId - currently selected route ID ('' = all)
 * @param {(id: string) => void} props.onChange - called with the new route ID
 */
const DashboardPersonaRouteFilter = ({ selectedRouteId, onChange }) => {
    const routes = useSharedCollection('PersonaRoutes')
    const list = useMemo(() => {
        const arr = Array.isArray(routes) ? [...routes] : []
        arr.sort((a, b) => (a?.Position ?? 0) - (b?.Position ?? 0))
        return arr
    }, [routes])

    if (list.length === 0) return null

    return (
        <label className="dashboard-filter-chip">
            <RouteOutlinedIcon fontSize="small" className="dashboard-filter-chip-icon" />
            <span className="dashboard-filter-chip-label">Traject:</span>
            <select
                className="dashboard-filter-chip-select"
                value={selectedRouteId || ''}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">Alle</option>
                {list.map((route) => (
                    <option key={route.ID} value={route.ID}>
                        {route.Title}
                    </option>
                ))}
            </select>
        </label>
    )
}

export default DashboardPersonaRouteFilter
